<template>
  <div class="progress-in-process">
    <template v-for="(step, index) in new Array(steps)" :key="index">
      <span :class="{ active: index <= currentStep }" />
    </template>
  </div>
</template>

<script>
export default {
  name: "InProcess",
  props: {
    steps: {
      type: Number,
      default: 3
    },
    currentStep: {
      type: Number,
      default: 0
    }
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/style/colors";

.progress-in-process {
  display: flex;
  justify-content: center;
  margin-top: 28px;
  margin-bottom: 16px;
}
  span {
    width: 22px;
    height: 6px;
    margin-right: 4px;
    background: #E8E3E0;
    border-radius: 1px;
  }
  .active {
    background: $orange;
  }
</style>